var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryFrontwheels1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 105,
    viewBox: "0 0 507 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 454.243,
    cy: 52.3639,
    r: 45.7354,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 12.1961
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.9479,
    cy: 52.3639,
    r: 45.7354,
    fill: "#9AFF6B",
    stroke: "black",
    strokeWidth: 12.1961
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.782,
    cy: 52.3639,
    r: 45.7354,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5025,
    cy: 52.3639,
    r: 45.7354,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 12.1961
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFrontwheels1);
export default __webpack_public_path__ + "static/media/battery-frontwheels1.698602b2f04c30a6d28e3eb165f1b7cd.svg";
export { ForwardRef as ReactComponent };